import classes from './SelectFilters.module.scss'
import Arrow from '../../../../accests/image/beforeArrowNext.svg'
import {useState} from "react";

const SelectFiltersTree2 = ({ name, isOpen, setIsOpen, options, activeOptions, setActiveOptions }) => {
   const checkIsShowId = (id) => {
      if (!!activeOptions.filter((item) => item === id).length) {
         setActiveOptions(activeOptions.filter((item) => item !== id))
      } else {
         setActiveOptions([...activeOptions, id])
      }
   }

   return (
      <div className={classes.wrapper}>
         <div className={classes.title} onClick={() => setIsOpen(!isOpen)}>
            <p>{name}</p>
            <img
               src={Arrow}
               alt='arrow'
               className={isOpen ? classes.isOpenImg : classes.rotateImg}
            />
         </div>
         {isOpen && (
            <div className={classes.optionsWrapper}>
               {options?.map((item) => (
                  <div
                     key={item.id}
                     className={classes.option}
                     onClick={() => checkIsShowId(item.id)}
                  >
                     <div className={classes.activeNameOption}>
                        <div
                           className={`${classes.checkBox} ${
                              !!activeOptions.filter((i) => i === item.id).length
                                 ? classes.activeCheckBox
                                 : ''
                           }`}
                        />
                        <div className={classes.text}>{item.value}</div>
                     </div>
                     <div className={classes.count}>{item.count}</div>
                  </div>
               ))}
            </div>
         )}
      </div>
   )
}

const GroupFilter = ({ group, activeOptions, setActiveOptions }) => {
   const [isOpen, setIsOpen] = useState(false);

   // Формируем уникальные id для каждой модели в группе
   //const productIds = group.products.map(option => `${group.brand}-${option.name}`);
   const productIds = group.products.map(option => `${option.name}`);
   // Если все id присутствуют в activeOptions – значит, бренд выбран
   const allSelected = productIds.every(id => activeOptions.includes(id));

   // При клике на галочку бренда выбираем/снимаем все модели
   const toggleBrand = (e) => {
      e.stopPropagation(); // чтобы не срабатывал onClick заголовка (expand/collapse)
      if (allSelected) {
         // Удаляем все id данной группы из activeOptions
         setActiveOptions(activeOptions.filter(item => !productIds.includes(item)));
      } else {
         // Добавляем все id данной группы, если их там нет
         const newActive = [...new Set([...activeOptions, ...productIds])];
         setActiveOptions(newActive);
      }
   };

   // При клике на отдельную модель (чекбокс) переключаем её состояние
   const toggleOption = (productName, e) => {
      e.stopPropagation(); // чтобы не менялось состояние раскрытия группы
      //const id = `${group.brand}-${productName}`;
      const id = `${productName}`;
      if (activeOptions.includes(id)) {
         setActiveOptions(activeOptions.filter(item => item !== id));
      } else {
         setActiveOptions([...activeOptions, id]);
      }
   };

   return (
       <div className={classes.group}>
          <div className={classes.title} onClick={() => setIsOpen(!isOpen)}>
             {/* Галочка для бренда */}
             <div style={{display:'flex', alignItems:'center'}}>
                <div
                    onClick={toggleBrand}
                    className={`${classes.checkBox} ${allSelected ? classes.activeCheckBox : ''}`}
                />
                <p style={{margin:0}}>{group.brand}</p>
             </div>
             <img
                 src={Arrow}
                 alt="arrow"
                 style={{margin:'10px 5px'}}
                 className={isOpen ? classes.isOpenImg : classes.rotateImg}
             />
          </div>
          {isOpen && (
              <div className={classes.optionsWrapper} style={{margin:'0 0 5px 20px'}}>
                 {group.products.map(option => {
                    //const id = `${group.brand}-${option.name}`;
                    const id = `${option.name}`;
                    const isActive = activeOptions.includes(id);
                    return (
                        <div
                            key={id}
                            className={classes.option}
                            onClick={(e) => toggleOption(option.name, e)}
                        >
                           <div className={classes.activeNameOption}>
                              <div
                                  className={`${classes.checkBox} ${isActive ? classes.activeCheckBox : ''}`}
                              />
                              <div className={classes.text}>{option.name}</div>
                           </div>
                           <div className={classes.count}>{option.count}</div>
                        </div>
                    );
                 })}
              </div>
          )}
       </div>
   );
};

// Основной компонент, который получает данные с вложенными списками
const SelectFiltersTree = ({ options, activeOptions, setActiveOptions, isOpen, setIsOpen, name }) => {
   return (
       <>
          <div className={classes.title} onClick={() => setIsOpen(!isOpen)}>
             <p style={{fontWeight: 500}}>{name}</p>
             <img
                 src={Arrow}
                 alt='arrow'
                 className={isOpen ? classes.isOpenImg : classes.rotateImg}
             />
          </div>
          {isOpen &&
              <div className={classes.wrapper} style={{margin:'10px 0 0 0'}}>
                 {options.map(group => (
                     <GroupFilter
                         key={group.brand}
                         group={group}
                         activeOptions={activeOptions}
                         setActiveOptions={setActiveOptions}
                     />
                 ))}
              </div>
          }
       </>
   );
};

export default SelectFiltersTree
